(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[512],{

/***/ 5109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./components/Footer/index.ts + 2 modules
var Footer = __webpack_require__(2689);
// EXTERNAL MODULE: ./components/Navbar/index.ts + 7 modules
var Navbar = __webpack_require__(7430);
// EXTERNAL MODULE: ./node_modules/react-no-ssr/index.js
var react_no_ssr = __webpack_require__(6467);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Layout/Layout.tsx






var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "h-full w-full overflow-hidden mx-auto",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_no_ssr["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* Navbar */.w, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* Footer */.$, {})]
  });
};

/* harmony default export */ var Layout_Layout = (Layout);
;// CONCATENATED MODULE: ./components/Layout/index.ts


/***/ }),

/***/ 2575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/PageHeader/PageHeader.tsx




var PageHeader = function PageHeader(_ref) {
  var topic = _ref.topic,
      detail = _ref.detail,
      backgroundImage = _ref.backgroundImage;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative w-screen h-fit lg:h-[27rem] bg-darkBlue flex justify-center items-center",
    children: [backgroundImage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute top-0 left-0 inset-0 z-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: backgroundImage,
        alt: "background-image-header",
        width: "100%",
        height: "100%",
        layout: "fill",
        objectFit: "cover"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      id: topic,
      className: "Container relative z-10 mt-20 lg:mt-8 mb-16 lg:mb-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "gradient-head-large w-fit text-dSmallBold leading-[5rem]",
        children: topic
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-white text-p1Medium mt-5",
        children: detail
      })]
    })]
  });
};

/* harmony default export */ var PageHeader_PageHeader = (PageHeader);
;// CONCATENATED MODULE: ./components/PageHeader/index.ts


/***/ }),

/***/ 3838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5109);
/* harmony import */ var _components_PageHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2575);
/* harmony import */ var _components_OldDesign_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6627);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);








var DataSubjectRightRequestPage = function DataSubjectRightRequestPage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_OldDesign_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      content: {
        title: 'Data Subject Rights Request - คำขอใช้สิทธิของเจ้าของข้อมูล CODIUM',
        content: 'ส่งคำขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลกับ CODIUM เรามุ่งมั่นในการปกป้องข้อมูลของคุณและปฏิบัติตามกฎหมายความเป็นส่วนตัวอย่างเคร่งครัด',
        image: null
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_PageHeader__WEBPACK_IMPORTED_MODULE_1__/* .PageHeader */ .m, {
      topic: "\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E0A\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34 \u0E02\u0E2D\u0E07\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25",
      detail: "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E22\u0E37\u0E48\u0E19\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E0A\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E02\u0E2D\u0E07\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25 (Data Subject Rights Request)",
      backgroundImage: "/images/data-subject-right-request/data-subject-right-request-page-header.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "relative w-screen h-fit py-16",
      style: {
        minHeight: '50vh'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("section", {
        className: "Container flex flex-col text-p1Regular text-gray-600",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
          children: ["\u0E17\u0E48\u0E32\u0E19\u0E43\u0E19\u0E10\u0E32\u0E19\u0E30\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E15\u0E32\u0E21\u0E1E\u0E23\u0E30\u0E23\u0E32\u0E0A\u0E1A\u0E31\u0E0D\u0E0D\u0E31\u0E15\u0E34\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25 \u0E1E.\u0E28. 2562 \u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49 (\u0E42\u0E1B\u0E23\u0E14\u0E28\u0E36\u0E01\u0E29\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "/privacy-policy",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
              className: "cursor-pointer text-lightBlue underline hover:text-lightBlue-500",
              children: "\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E2F"
            })
          }), ' ', ") \u0E2B\u0E32\u0E01\u0E17\u0E48\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E17\u0E48\u0E32\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E21\u0E32\u0E17\u0E35\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
            href: "mailto:contact@codium.co",
            className: "cursor-pointer text-lightBlue underline hover:text-lightBlue-500",
            children: "contact@codium.co"
          }), ' ', "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E41\u0E25\u0E49\u0E27\u0E40\u0E23\u0E32\u0E08\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E32\u0E21\u0E04\u0E33\u0E02\u0E2D \u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E20\u0E32\u0E22\u0E43\u0E19 30 \u0E27\u0E31\u0E19\u0E19\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E27\u0E31\u0E19\u0E17\u0E35\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "mt-10",
          children: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14 24 \u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19 2569"
        })]
      })
    })]
  });
};

DataSubjectRightRequestPage.getLayout = function (page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_0__/* .Layout */ .A, {
    children: page
  });
};

/* harmony default export */ __webpack_exports__["default"] = (DataSubjectRightRequestPage);

/***/ }),

/***/ 8982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-subject-right-request",
      function () {
        return __webpack_require__(3838);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [735,467,60,774,888,179], function() { return __webpack_exec__(8982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);